if (!customElements.get('blog-ajax')) {
    class BlogAjax extends HTMLElement {
      constructor() {
        super();
        this.posts = Array.from(this.querySelectorAll('.js-blog-post-wrap'));
        this.itemsLoad = this.dataset.itemsLoad || 12;
        this.grid = this.querySelector('.js-grid');
        this.loadBtn = this.querySelector('.js-load-more');
        this.loadBtnParent = this.querySelector('.js-load-more-parent');
        if (this.dataset.blogUrl != '') {
          this.blogUrls = this.dataset.blogUrl.split(' ');
        }
        else {
          this.blogUrls = document.querySelector('[data-all-blogs-urls]')?.dataset.allBlogsUrls.split(' ');
        }
        console.log('blog urls', this.blogUrls);
        
        this.loadBtn.addEventListener('click', this.loadMore.bind(this));
        this.page = 2;
        this.insertedCount = 0;
        if (this.dataset.blogCount != '') {
          this.totalCount = this.dataset.blogCount*1;
        }
        else {
          this.totalCount = document.querySelector('[data-all-blogs-count]')?.dataset.allBlogsCount*1;
        }
      }
      async connectedCallback() {
        await this.loadMore();
      }
  
      async loadMore() {
        await this.getPosts();
        this.sortPosts();
        this.insertPosts();
      }
  
      sortPosts() {
        this.posts.sort((a, b) => b.dataset.published*1 - a.dataset.published*1)
      }
  
      insertPosts() {
        if (this.posts.length) {
          let posts = this.posts.splice(0, this.itemsLoad);
          this.insertedCount += posts.length;
          posts.forEach(article => {
            this.grid.insertAdjacentElement('beforeend', article.querySelector('.article__item'))
          })
          this.loadBtnParent.classList.remove('tw-hidden');
        }
        console.log(this.insertedCount, "of", this.totalCount);
        
        if (this.insertedCount >= this.totalCount) {
          this.loadBtnParent.classList.add('tw-hidden');
        }
      }
      
      async getPosts() {
        if (this.posts.length >= this.itemsLoad) return;
  
        let postsLenBefore = this.posts.length;
        for (let index = 0; index < this.blogUrls.length; index++) {
          const pageUrl = this.blogUrls[index]+`?view=ajax&page=${this.page}`;
          const response = await fetch(pageUrl, { method: 'GET' });
          const html = await response.text();
          const dom = new DOMParser().parseFromString(html, 'text/html');
          const items = dom.querySelectorAll('.js-blog-post-wrap');
          items.forEach(item => {
            this.posts = this.posts.concat(item);
          })
        }
        let newPostsFound = this.posts.length > postsLenBefore;
        if (newPostsFound) {
          this.page++;
          await this.getPosts();
        }
      }
    }
    
    customElements.define('blog-ajax', BlogAjax);
  }